import { ONBOARDING_TUTORIAL_STEPS } from './onboarding.types'
import { WEBAPP_LOCAL_STORAGE_KEYS } from '../../../models/browserStorage.types'

// Pure onboarding step-sequence logic, extracted from OnboardingFlowController so it can be
// unit-tested without booting the React/Redux tree. No React/hook dependencies belong here.

const getOnboardingStepsByVersion = (
  version: WEBAPP_LOCAL_STORAGE_KEYS,
  isDefaultGuidedAutoSaveEnabled: boolean,
  doesUserGetSessions: boolean,
) => {
  switch (version) {
    case WEBAPP_LOCAL_STORAGE_KEYS.CurrentOnboardingTutorialStepV2:
      return [
        ONBOARDING_TUTORIAL_STEPS.Preface,
        ONBOARDING_TUTORIAL_STEPS.Intro,
        ONBOARDING_TUTORIAL_STEPS.Stats,
        ONBOARDING_TUTORIAL_STEPS.PinTabs,
        isDefaultGuidedAutoSaveEnabled
          ? ONBOARDING_TUTORIAL_STEPS.GuidedAutoSave
          : ONBOARDING_TUTORIAL_STEPS.AutoSaveConfig,
        ONBOARDING_TUTORIAL_STEPS.TabList,
        ONBOARDING_TUTORIAL_STEPS.NewFolderButton,
        ONBOARDING_TUTORIAL_STEPS.FolderCreation,
        ONBOARDING_TUTORIAL_STEPS.FolderCreated,
        ONBOARDING_TUTORIAL_STEPS.DraftProjects,
        ONBOARDING_TUTORIAL_STEPS.Conclusion,
      ]
    case WEBAPP_LOCAL_STORAGE_KEYS.CurrentOnboardingTutorialStepV3:
      return [
        ONBOARDING_TUTORIAL_STEPS.PrefaceV3,
        ONBOARDING_TUTORIAL_STEPS.HowSkipperWorks,
        ONBOARDING_TUTORIAL_STEPS.GettingStarted,
        ONBOARDING_TUTORIAL_STEPS.StatsV3,
        ONBOARDING_TUTORIAL_STEPS.PinTabsV3,
        ONBOARDING_TUTORIAL_STEPS.BreatheEasy,
        ...(doesUserGetSessions
          ? [
              ONBOARDING_TUTORIAL_STEPS.Sessions,
              ONBOARDING_TUTORIAL_STEPS.SessionsOrganize,
              ONBOARDING_TUTORIAL_STEPS.SessionsCleanUp,
              ONBOARDING_TUTORIAL_STEPS.SessionsComplete,
            ]
          : []),
        ONBOARDING_TUTORIAL_STEPS.GuidedAutoSaveV3,
        ONBOARDING_TUTORIAL_STEPS.GuidedOrAutoSavePickerV3,
        ONBOARDING_TUTORIAL_STEPS.ConclusionV3,
      ]
    default:
      return []
  }
}

export const getOnboardingStepSequence = (params: {
  isDefaultGuidedAutoSaveEnabled: boolean
  version: WEBAPP_LOCAL_STORAGE_KEYS
  doesUserGetSessions: boolean
}): ONBOARDING_TUTORIAL_STEPS[] => {
  const { isDefaultGuidedAutoSaveEnabled, version, doesUserGetSessions } = params
  return getOnboardingStepsByVersion(version, isDefaultGuidedAutoSaveEnabled, doesUserGetSessions)
}
